import useTranslation from 'next-translate/useTranslation'
import React, { useEffect } from 'react'
import useMatchLoads from 'tennders-market/load/hooks/useMatchLoads'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import GLoading from 'tennders-market/common/components/element/GLoading'
import DistanceFilter from './DistanceFilter'
import MatchTransactions from './MatchTransactions'

const MatchLoads = () => {
  const {
    loading,
    fetchLoads,
    loads,
    setrange,
    range,
    dateRange,
    setdateRange
  } = useMatchLoads()
  const { t } = useTranslation()
  const { transaction } = useTransaction()

  useEffect(() => {
    fetchLoads(transaction?.id)
  }, [])

  return (
    <>
      <div className="d-flex justify-space align-center mb-20">
        <h3 className="bold mb-0 mr-10">
          {t('transaction:loadsMatched')}
        </h3>
        <DistanceFilter
          dateRange={dateRange}
          setdateRange={setdateRange}
          setrange={setrange}
          range={range}
        />
      </div>
      {loading
        ? <GLoading />
        : (
          <MatchTransactions
            type="load"
            noMatchText={t('transaction:noLoadsToMatch')}
            onRefresh={fetchLoads}
            transactions={loads}
          />
        )}
    </>
  )
}

export default MatchLoads
